module.exports = __webpack_public_path__ + "img/mail.5c4dad55.png";